import React from 'react';
import { TextField } from 'wix-ui-tpa';
import withErrorMessage from '../../withErrorMessage';
import { st, classes } from './ComplexPhone.st.css';
import { COUNTRIES_CODES, } from '@wix/forms-common/dist/src/locale-dataset/country-codes';
import { withReadonlySuffix } from '../../../../hooks/withReadonlySuffix';
import { CountryCodeDropdown } from './CountryDropdown';
import { CountryCodeAutoComplete } from './CountryAutoComplete';
const ComplexPhoneComponent = ({ onBlur, onChange, field: { renderInfo }, invalidMessage, errorMessageId, theme, className, required, disabled, value = { countryCode: '', phone: '' }, readonly, isMobile, showAutoComplete, translateMessage, }) => {
    var _a;
    const maxLength = (_a = renderInfo === null || renderInfo === void 0 ? void 0 : renderInfo.validationProperties) === null || _a === void 0 ? void 0 : _a.maxLength;
    const { countryCode, phone } = value;
    const onValueBlur = () => {
        onBlur({
            countryCode,
            phone,
            prefix: COUNTRIES_CODES[countryCode],
        });
    };
    const onValueChange = (newPhone) => {
        if (maxLength === undefined ||
            (maxLength && newPhone.length <= maxLength)) {
            onChange({
                countryCode,
                phone: newPhone,
                prefix: COUNTRIES_CODES[countryCode],
            });
        }
    };
    const onCountryCodeChange = (newCountryCode) => {
        onChange({
            countryCode: newCountryCode,
            phone,
            prefix: COUNTRIES_CODES[newCountryCode],
        });
    };
    const renderInput = () => {
        var _a, _b, _c;
        return (React.createElement("div", { className: classes.inputWrapper },
            React.createElement(TextField, { "data-hook": "input", theme: theme, className: classes.input, placeholder: (_a = renderInfo === null || renderInfo === void 0 ? void 0 : renderInfo.displayProperties) === null || _a === void 0 ? void 0 : _a.placeholder, value: phone, disabled: disabled, readOnly: readonly, suffix: withReadonlySuffix(readonly), type: "tel", error: !!invalidMessage, onBlur: () => onValueBlur(), onChange: (e) => onValueChange(e.target.value), required: required, maxLength: (_b = renderInfo === null || renderInfo === void 0 ? void 0 : renderInfo.validationProperties) === null || _b === void 0 ? void 0 : _b.maxLength, pattern: (_c = renderInfo === null || renderInfo === void 0 ? void 0 : renderInfo.validationProperties) === null || _c === void 0 ? void 0 : _c.pattern, "aria-describedby": invalidMessage ? errorMessageId : undefined })));
    };
    const renderDropdown = () => {
        return (React.createElement(CountryCodeDropdown, { invalidMessage: invalidMessage, theme: theme, disabled: disabled, countryCode: countryCode, isMobile: isMobile, onCountryCodeChange: onCountryCodeChange }));
    };
    const renderAutoComplete = () => {
        return (React.createElement(CountryCodeAutoComplete, { countryCode: countryCode, invalidMessage: invalidMessage, theme: theme, disabled: disabled, onCountryCodeChange: onCountryCodeChange, translateMessage: translateMessage }));
    };
    const renderCountryPrefix = () => {
        if (showAutoComplete) {
            return renderAutoComplete();
        }
        else {
            return renderDropdown();
        }
    };
    const renderLabel = () => {
        var _a;
        const label = (_a = renderInfo === null || renderInfo === void 0 ? void 0 : renderInfo.displayProperties) === null || _a === void 0 ? void 0 : _a.label;
        return label ? (React.createElement("legend", { "data-hook": "label", className: classes.label }, label)) : null;
    };
    return (React.createElement("fieldset", { className: st(classes.root, { required: required || false, mobile: !!isMobile }, className), "data-hook": "complex-phone-field" },
        renderLabel(),
        React.createElement("div", { className: classes.field },
            renderCountryPrefix(),
            renderInput())));
};
export default withErrorMessage(ComplexPhoneComponent);
//# sourceMappingURL=ComplexPhone.js.map